export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '2bc1d3a7-7293-4189-af10-f46d3639d67f';
export const MODAL_CLOSE_SEC = 1.5;



// import { findIndex } from "core-js/core/array";
// import { findIndex } from "core-js/stable";
// import 'core-js/features/array/find-index'; 